import { getCookie } from './getCookie';

export const getCulture = (): string => getCookie(`CP_SAS_CULTURE`);
